import { Cpu } from 'lucide-react';
import { List } from 'lucide-react';
import { Users } from 'lucide-react';
import { BookUser } from 'lucide-react';
import {Navbar} from "../../../components/navbar/navbar";
import React, {useEffect, useState} from "react";

import './Prestataire.scss'
import {Tabs} from "@mantine/core";
import {Utilisateurs_liste} from "./Utilisateurs_liste/Utilisateurs_liste";
import {useDispatch} from "react-redux";
import {setMobile_sidebar_icon} from "../../../store/interfaceSlice";
import {Capteurs_liste_admin} from "./Capteurs_liste_admin/Capteurs_liste_admin";
import {Logs_viewer_bureau_etude} from "../Bureau_etudes/logs_viewer_bureau_etude";
import {Commerciaux_admin} from "./Commerciaux_admin/Commerciaux_admin";
import {useLocation, useParams} from "react-router-dom";



export function Prestataire() {

    const dispatch = useDispatch();
    dispatch(setMobile_sidebar_icon("aucun"))

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const [activeTab, setActiveTab] = useState<string | null>(tab ?? 'users');


    return (
        <div className={"app"}>
            <Navbar/>
            <div className={"content content-fullwidth page_be"}>
                <Tabs className={"Tabs"} value={activeTab} onChange={setActiveTab}>
                    <Tabs.List>
                        <Tabs.Tab value="users" leftSection={<Users />}>Utilisateurs</Tabs.Tab>
                        <Tabs.Tab value="commerciaux" leftSection={<BookUser />}>Commerciaux</Tabs.Tab>
                        <Tabs.Tab value="capteurs" leftSection={<Cpu />}>Enregistreurs</Tabs.Tab>
                        <Tabs.Tab value="logs" leftSection={<List />}>Logs</Tabs.Tab>
                        {/*<Tabs.Tab value="page5" icon={<Icone nom={"gear"} />}>Page 5</Tabs.Tab>*/}
                    </Tabs.List>

                    <Tabs.Panel value="users" pt="xs">
                        {activeTab === "users" && (
                            <Utilisateurs_liste />
                        )}
                    </Tabs.Panel>

                    <Tabs.Panel value="commerciaux" pt="xs">
                        {activeTab === "commerciaux" && (
                            <Commerciaux_admin />
                        )}
                    </Tabs.Panel>

                    <Tabs.Panel value="capteurs" pt="xs">
                        {activeTab === "capteurs" && (
                            <Capteurs_liste_admin />
                        )}
                    </Tabs.Panel>

                    <Tabs.Panel value="logs" pt="xs">
                        {activeTab === "logs" && (
                            <Logs_viewer_bureau_etude />
                        )}
                    </Tabs.Panel>

                    {/*<Tabs.Panel value="page5" pt="xs">*/}
                    {/*    Page 5...*/}
                    {/*</Tabs.Panel>*/}
                </Tabs>
            </div>
        </div>

    );
}
